import { render, staticRenderFns } from "./social-media-color-blocks.vue?vue&type=template&id=7248910c&scoped=true&"
import script from "./social-media-color-blocks.vue?vue&type=script&lang=js&"
export * from "./social-media-color-blocks.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=7248910c&scoped=true&lang=css&"
import style1 from "./social-media-color-blocks.vue?vue&type=style&index=1&id=7248910c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7248910c",
  null
  
)

export default component.exports